import {InView} from "react-intersection-observer";

const Floating = (props) => {
    return <InView triggerOnce={true} delay={200} threshold={0.5}>
        {({inView, ref, entry}) => <div ref={ref} className={`${inView ? 'floating' : ''}`} {...props}>{props.children}</div>}
    </InView>;
};

export default Floating;
